import { FaAngleDown, FaTrashAlt } from "react-icons/fa";
import {
  colors,
  constants,
  gql,
  React,
  styl,
  styled,
  useEffect,
  useState,
} from "../../imports";
import Alert from "../Alert";
import useAmountInput from "../hooks/useAmountInput";
import { useCheckAsPaid } from "../hooks/useCheckAsPaid";
import useRemoveFromCart from "../hooks/useRemoveFromCart";
import useWindowSize from "../hooks/useWindowSize";
import SingleSelect from "../SingleSelect";
import StyledButton from "../StyledButton";
import "./Accordion.css";
import CoolBoxInfo from "../CoolBoxInfo";
import { AmountInput } from "./AccordionSingleBuyer";

function AccordionNotInitiator({ data, list, index, orderId, parentPage }) {
  const [dropDownIndex, setDropDownIndex] = useState(-1);
  const [dropDown2Index, setDropDown2Index] = useState(-1);
  const [inputState, setInputState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [deleteProduct, setDeleteProduct] = useState(false);
  const { debouncedInputHandle, loadingUpdateAmount } = useAmountInput();
  const { removeSelected } = useRemoveFromCart();
  const { checkAsPaid } = useCheckAsPaid();
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const size = useWindowSize();

  const handleChannel = (channel, index) => {
    //Ausklappen der Hauptkategorie

    if (dropDownIndex == index) {
      setDropDownIndex(-1);
    } else {
      setDropDownIndex(index);
    }
  };

  useEffect(() => {
    if (data.length == 1) {
      handleInputState(data[0].orderers[0].products);
    }
  }, []);
  const handleChannel2 = (channel, index, products) => {
    //Ausklappen der Hauptkategorie
    setInputState([]);

    if (dropDown2Index == index) {
      setDropDown2Index(-1);
      setInputState([]);
    } else {
      setDropDown2Index(index);
      let tmp = [];
      products.map((item) => {
        tmp.push(item.amount);
      });
      setInputState(tmp);
    }
  };

  const handleInputState = (products) => {
    let tmp = [];
    products.map((item) => {
      tmp.push(item.amount);
    });
    setInputState(tmp);
  };

  const removeItemFromList = async (product, i2) => {
    setLoadingRemove(true);
    let tmp = inputState;
    tmp.splice(i2, 1);
    setInputState(tmp);
    await removeSelected(product.rowId, "");
    // if(await removeSelected(product.rowId, "")){
    //   setLoading(false)
    // }
    // else{
    //   setLoading(false)
    // }
    setLoadingRemove(false);
    setShowDeleteAlert(false);
  };

  return (
    <Wrapper key={"Hallo"}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ContentContainer className={parentPage}>
          <NameContainer>
            <FaAngleDown
              color="#707070"
              onClick={() => {
                handleChannel(list.name, index);
              }}
              className="fa fa-chevron-down"
              style={
                dropDownIndex == index ? { transform: "rotate(180deg)" } : {}
              }
            />

            {list.name != "other" ? list.name : "Sonstige"}
          </NameContainer>
          {!loading && (
            <NameContainer>
              €{" "}
              {list.total.toLocaleString("DE-DE", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              })}
            </NameContainer>
          )}
        </ContentContainer>
      </div>
      <DropdownContainer
        style={
          dropDownIndex == index ? { display: "block" } : { display: "none" }
        }
      >
        {list.orderers.map((orderer, i) => {
          return (
            <Wrapper key={"Hallo"}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <ContentContainer2 className={parentPage}>
                  <NameContainer>
                    <FaAngleDown
                      onClick={() => {
                        handleChannel2(orderer.name, i, orderer.products);
                      }}
                      className="fa fa-chevron-down"
                      color="#707070"
                      style={
                        dropDown2Index == i
                          ? { transform: "rotate(180deg)" }
                          : {}
                      }
                    />
                    {orderer.name}
                  </NameContainer>
                  {!loading && (
                    <NameContainer>
                      €{" "}
                      {orderer.total.toLocaleString("DE-DE", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })}
                    </NameContainer>
                  )}
                </ContentContainer2>
                {orderId && (
                  <div
                    style={{
                      paddingLeft: "30px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SingleSelect
                      min={"0px"}
                      checked={orderer.paid}
                      onChange={(value) => {
                        checkAsPaid(orderer.paidRowId, orderId, value);
                      }}
                    />
                  </div>
                )}
              </div>
              <DropdownContainer
                style={
                  dropDown2Index == i
                    ? { display: "block" }
                    : { display: "none" }
                }
                className={parentPage}
              >
                {!loadingRemove && !loadingUpdateAmount ? (
                  orderer.products.map((product, i2) => {
                    return (
                      <ProductContainer
                        key={i2}
                        className={i2}
                        style={{ opacity: 1 }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <SubCheckboxLabel>
                            {/* <select name="cars" id="cars">
                              <option value="volvo">Volvo</option>
                              <option value="saab">Saab</option>
                              <option value="opel">Opel</option>
                              <option value="audi">Audi</option>
                            </select> */}
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  maxHeight: "36px",
                                  alignItems: "center",
                                }}
                              >
                                {product.rowId &&
                                parentPage !== "OrderOverview" ? (
                                  <AmountInput
                                    onChange={async (e) => {
                                      setLoading(true);
                                      if (e.target.value != "") {
                                        let tmp = inputState.slice();
                                        if (e.target.value == "0") {
                                          tmp[i2] = "1";
                                        } else {
                                          tmp[i2] = e.target.value;
                                        }
                                        setInputState(tmp);
                                        await debouncedInputHandle(
                                          product,
                                          tmp[i2]
                                        );
                                        setLoading(false);
                                      }
                                    }}
                                    value={inputState[i2]}
                                    readOnly={
                                      parentPage == "OrderOverview"
                                        ? true
                                        : false
                                    }
                                    type={"number"}
                                  ></AmountInput>
                                ) : (
                                  <Paragraph>{product.amount}x</Paragraph>
                                )}
                                {/* <SubCheckboxInput id={product.product.name} type="checkbox" onChange={() => { }} checked={false} /> */}
                                {/* <SubCheckboxButton className="fa fa-check" /> */}
                                <ProductName>
                                  {product.product.name}
                                </ProductName>
                                {product.product.parent?.coolbox
                                  ?.coolboxActivated && <CoolBoxInfo />}
                              </div>
                              {!loading && (
                                <ProductName>
                                  €{" "}
                                  {product.total.toLocaleString("DE-DE", {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2,
                                  })}
                                </ProductName>
                              )}
                            </div>
                            {size.width < constants.nexusPortraitWidth &&
                              !orderId &&
                              parentPage != "OrderOverview" && (
                                <IconText
                                  onClick={async () => {
                                    setDeleteProduct({
                                      product: product,
                                      i2: i2,
                                    });
                                    setShowDeleteAlert(true);
                                  }}
                                >
                                  Produkt entfernen
                                </IconText>
                              )}
                          </SubCheckboxLabel>

                          {!orderId && parentPage != "OrderOverview" && (
                            <DeleteWrapper>
                              {size.width > constants.nexusPortraitWidth && (
                                <Item>
                                  <FaTrashAlt
                                    onClick={async () => {
                                      setDeleteProduct({
                                        product: product,
                                        i2: i2,
                                      });
                                      setShowDeleteAlert(true);
                                    }}
                                    color="#E1E1E1"
                                    height="16px"
                                  />
                                </Item>
                              )}
                            </DeleteWrapper>
                          )}
                          {showDeleteAlert && deleteProduct && (
                            <Alert isVisible={true}>
                              <Paragraph>
                                Willst du dieses Produkt wirklich entfernen?
                              </Paragraph>
                              <ButtonBox>
                                <div style={{ width: "180px" }}>
                                  <StyledButton
                                    // loading={mutationLoading}
                                    scale={"DEFAT"}
                                    title={"Abbrechen"}
                                    color={colors.YellowBrigthButton}
                                    fontSize={"20px"}
                                    onClick={() => {
                                      // handleCheckAGB();
                                      setDeleteProduct(false);
                                      setShowDeleteAlert(false);
                                    }}
                                  />
                                </div>
                                <div style={{ width: "10px", height: "5px" }} />
                                <div style={{ width: "180px" }}>
                                  <StyledButton
                                    // loading={mutationLoading}
                                    scale={"DEULT"}
                                    title={"entfernen"}
                                    color={colors.YellowBrigthButton}
                                    fontSize={"20px"}
                                    onClick={() => {
                                      removeItemFromList(
                                        deleteProduct.product,
                                        deleteProduct.i2
                                      );
                                      setDeleteProduct(false);
                                    }}
                                  />
                                </div>
                              </ButtonBox>
                            </Alert>
                          )}
                        </div>
                      </ProductContainer>
                    );
                  })
                ) : (
                  <p>Loading...</p>
                )}
              </DropdownContainer>
            </Wrapper>
          );
        })}
      </DropdownContainer>
    </Wrapper>
  );
}

export default AccordionNotInitiator;

const Wrapper = styled.li`
  /* position: relative; */
  list-style: none;
`;
const ContentContainer = styled.div`
  /* background-size: cover; */
  width: 100%;
  margin-right: 50px;
  max-height: 36px;
  /* background-position: center; */
  color: black;

  &.OrderOverview {
    margin: 0;
  }

  display: flex;
  justify-content: space-between;
  flex-flow: row;
  align-items: center;
  border-bottom: 1px solid #e1e1e1;
  @media (max-width: ${constants.nexusPortraitWidth}px) {
    margin-right: 0;
  }
`;

const ContentContainer2 = styled(ContentContainer)`
  /* padding-left: 10px; */
  /* max-width: 300px; */
  width: 100%;
  margin-left: 10px;
  background-color: ${colors.YellowBrigthButton};
  &.OrderOverviewWithId {
    margin-right: 0;
  }
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  /* z-index: 3; */
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-family: "Montserrat";
  font-weight: 300;
  color: #333333;
  letter-spacing: 0.35px;
  height: 30px;
`;

const DropdownContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  /* max-width: 330px; */
  transition: height 0.3s ease;
  /* overflow-y: hidden; */
  z-index: 1;
  &.OrderOverviewWithId {
    margin-right: 50px;
    @media (max-width: ${constants.nexusPortraitWidth}px) {
      margin-right: 0;
    }
  }
`;

const ProductContainer = styled.li`
  list-style: none;
  padding: 0px;
  margin: 0px;
  transition: 0.3s ease;
  opacity: 0;
`;

const SubCheckboxLabel = styled.label`
  margin: 0px;
  padding: 0px;

  height: 36px;
  background-color: white;
  display: flex;
  flex-flow: column;
  justify-content: center;
  font-size: 14px;
  margin-left: 10px;
  width: 100%;
  border-bottom: 0.8px solid ${colors.MercuryGreyInputfields};
  @media (max-width: ${constants.nexusPortraitWidth}px) {
    height: unset;
  }
`;

const ProductName = styled.h6`
  font-size: 14px;
  font-family: "Montserrat";
  font-weight: 300;
  color: #808080;
  padding: 0px;
  padding-left: 11px;
  margin: 0px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;
const IconText = styled.div`
  font-size: 12px;
  text-decoration: underline;
  color: ${colors.YellowBrigthButton};
  cursor: pointer;
  text-align: right;
  margin: 12px 0 5px 0;
  &:hover {
    opacity: 0.6;
  }
`;

const Paragraph = styled.p`
  font-family: "Montserrat";
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 0.35;
  color: #808080;
  margin: 0;
`;

const Item = styled.div`
  width: 50px;
  ${styl.flexRow};
  align-items: center;
  justify-content: center;
  /* position: relative; */
  /* min-width: ${(props) => (props.min ? props.min : "240px")}; */
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  flex-flow: ${(props) => (props.alignment == "RIGHT" ? "row-reverse" : "row")};

  @media (max-width: 375px) {
    display: none;
  }
`;

const DeleteWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  hyphens: auto;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`;
